import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import MarqueeStrip from "../components/MarqueeStrip";
import Mission from "../components/Mission";
import Program from "../components/Program";
import WhySport from "../components/WhySport";
import Activities from "../components/Activities";
import Impact from "../components/Impact";
import News from "../components/News";
import Events from "../components/Events";
import Partners from "../components/Partners";
import Team from "../components/Team";
import Legacy from "../components/Legacy";
import Donate from "../components/Donate";
import Footer from "../components/Footer";

export default function Home() {
    return (
        <div className="bg-ink text-white grain" data-testid="home-page">
            <Header />
            <main>
                <Hero />
                <MarqueeStrip />
                <Mission />
                <WhySport />
                <Program />
                <Activities />
                <Team />
                <Legacy />
                <Partners />
                <News />
                <Events />
                <Impact />
                <Donate />
            </main>
            <Footer />
        </div>
    );
}
